<button
  (click)="onClick()"
  class="omni-summary-card cover-border"
  type="button"
  *ngIf="(shouldEnablePreChatWelcome$ | async) === false"
>
  <div class="omni-summary-card-content">
    <cigna-icon-dynamic
      [icon]="icon"
      [colors]="iconColors"
      [data]="iconData"
      class="omni-summary-card-content-icon"
    ></cigna-icon-dynamic>

    <div
      class="omni-summary-card-content-copy"
      [ngClass]="{ bold: newMessages }"
    >
      <div data-omni-qa="omni-summary-card-content-copy">
        <span
          class="subject"
          [ngClass]="{ closed: isClosed }"
          data-omni-qa="omni-summary-card-subject"
          >{{ subject }}</span
        >
        <span class="divider">|</span>
        <span data-omni-qa="omni-summary-card-dateTime">{{
          date | omniSummaryCardDatetimePipe | async
        }}</span>
      </div>
      <p data-omni-qa="omni-summary-card-body">{{ body }}</p>
    </div>
  </div>
  <cigna-icon-dynamic-chevron
    [colors]="chevronColor"
    [data]="iconData"
    class="omni-summary-card-chevron"
  ></cigna-icon-dynamic-chevron>
</button>

<!-- For new pre chat design -->
<button
  (click)="onClick()"
  class="omni-summary-card new-card-summary"
  type="button"
  *ngIf="shouldEnablePreChatWelcome$ | async"
>
  <div class="omni-summary-card-content">
    <div
      class="omni-summary-card-content-copy lineAlign"
      [ngClass]="{ bold: newMessages }"
    >
      <div data-omni-qa="omni-summary-card-content-copy lineAlign">
        <span
          class="subject"
          [ngClass]="isClosed ? 'closed grey' : 'green'"
          data-omni-qa="omni-summary-card-subject"
          >{{ subject }}</span
        >
        <span class="new-divider"></span>
        <span data-omni-qa="omni-summary-card-dateTime">{{
          date | omniSummaryCardDatetimePipe | async
        }}</span>
      </div>
      <p data-omni-qa="omni-summary-card-body">{{ body }}</p>
    </div>
  </div>
  <cigna-icon-dynamic-chevron
    [colors]="chevronColor"
    [data]="iconData"
    class="omni-summary-card-chevron"
  ></cigna-icon-dynamic-chevron>
</button>
